import { Validator } from '@vista-digital/validator';
import { defaultMemberJourneyListAssets, memberJourneyListAssetsValidator } from './assets';
import { defaultMemberJourneyListCdnOptions, memberJourneyListCdnOptionsValidator } from './cdn-options';
import { defaultMemberJourneyListConfig, memberJourneyListConfigValidator } from './config';
import { defaultMemberJourneyListDisplayText, memberJourneyListDisplayTextValidator } from './display-text';
import { defaultMemberJourneyListEvents, memberJourneyListEventsValidator } from './events';
export const memberJourneyListPropsValidator = Validator.object({
    config: memberJourneyListConfigValidator,
    displayText: memberJourneyListDisplayTextValidator,
    events: memberJourneyListEventsValidator,
    assets: memberJourneyListAssetsValidator,
    cdnOptions: memberJourneyListCdnOptionsValidator
});
export const defaultMemberJourneyListProps = {
    config: defaultMemberJourneyListConfig,
    displayText: defaultMemberJourneyListDisplayText,
    events: defaultMemberJourneyListEvents,
    assets: defaultMemberJourneyListAssets,
    cdnOptions: defaultMemberJourneyListCdnOptions
};
